import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { OrderRefusalDialogComponent } from './order-refusal-dialog.component';
import { CustomerAccountModule } from '../../customer-account/customer-account.module';

@NgModule({ declarations: [OrderRefusalDialogComponent],
  imports: [CommonModule, CustomerAccountModule, FormsModule, ReactiveFormsModule, MatDialogModule, MatButtonModule,
    MatFormFieldModule, MatInputModule, MatSelectModule, MatProgressBarModule] })
export class OrderRefusalModule {}
